module.exports = __webpack_public_path__ + "static/img/home_news_pic.1eaad20c.png";